module.exports = __webpack_public_path__ + "img/left_caret.839db18b.svg";